import React from 'react';
import { Card } from '../components/ui/Card';
import { SearchIcon, PlusIcon, FilterIcon, DownloadIcon } from 'lucide-react';
export const Admissions = () => {
  return <div className="space-y-6" data-id="element-86">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-87">
        <div data-id="element-88">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-89">
            Admissions Management
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-90">
            Manage student applications and enrollment
          </p>
        </div>
        <div className="mt-4 sm:mt-0" data-id="element-91">
          <button className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-92">
            <PlusIcon size={18} className="mr-1" data-id="element-93" />
            <span data-id="element-94">New Application</span>
          </button>
        </div>
      </div>
      <Card data-id="element-95">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between pb-4 border-b border-gray-200" data-id="element-96">
          <div className="relative" data-id="element-97">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-98">
              <SearchIcon size={18} className="text-gray-400" data-id="element-99" />
            </span>
            <input type="text" placeholder="Search applicants..." className="pl-10 pr-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 w-full sm:w-64" data-id="element-100" />
          </div>
          <div className="mt-3 sm:mt-0 flex space-x-2" data-id="element-101">
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-102">
              <FilterIcon size={16} className="mr-1" data-id="element-103" />
              <span data-id="element-104">Filters</span>
            </button>
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-105">
              <DownloadIcon size={16} className="mr-1" data-id="element-106" />
              <span data-id="element-107">Export</span>
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-108">
          <table className="min-w-full divide-y divide-gray-200 mt-4" data-id="element-109">
            <thead className="bg-gray-50" data-id="element-110">
              <tr data-id="element-111">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-112">
                  Applicant
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-113">
                  Application ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-114">
                  Program
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-115">
                  Submitted
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-116">
                  Status
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-117">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-118">
              {[{
              name: 'Rahul Sharma',
              id: 'APP23001',
              program: 'B.Tech Computer Science',
              date: 'Aug 12, 2023',
              status: 'Under Review'
            }, {
              name: 'Priya Patel',
              id: 'APP23014',
              program: 'BBA',
              date: 'Aug 11, 2023',
              status: 'Documents Pending'
            }, {
              name: 'Amit Kumar',
              id: 'APP23022',
              program: 'B.Sc Physics',
              date: 'Aug 10, 2023',
              status: 'Interview Scheduled'
            }, {
              name: 'Neha Singh',
              id: 'APP23035',
              program: 'B.Com',
              date: 'Aug 09, 2023',
              status: 'Approved'
            }, {
              name: 'Vikram Joshi',
              id: 'APP23041',
              program: 'B.Tech Electronics',
              date: 'Aug 08, 2023',
              status: 'Waitlisted'
            }, {
              name: 'Anjali Desai',
              id: 'APP23048',
              program: 'M.Sc Chemistry',
              date: 'Aug 07, 2023',
              status: 'Approved'
            }, {
              name: 'Rajesh Khanna',
              id: 'APP23052',
              program: 'MBA',
              date: 'Aug 06, 2023',
              status: 'Under Review'
            }, {
              name: 'Sonia Gupta',
              id: 'APP23067',
              program: 'B.Tech Mechanical',
              date: 'Aug 05, 2023',
              status: 'Documents Pending'
            }].map((applicant, index) => <tr key={index} data-id="element-119">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-120">
                    <div className="flex items-center" data-id="element-121">
                      <div className="flex-shrink-0 h-8 w-8 bg-indigo-100 rounded-full flex items-center justify-center" data-id="element-122">
                        <span className="text-xs font-medium text-indigo-800" data-id="element-123">
                          {applicant.name.split(' ').map(n => n[0]).join('')}
                        </span>
                      </div>
                      <div className="ml-4" data-id="element-124">
                        <div className="text-sm font-medium text-gray-900" data-id="element-125">
                          {applicant.name}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-126">
                    {applicant.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-127">
                    {applicant.program}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-128">
                    {applicant.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-129">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${applicant.status === 'Approved' ? 'bg-green-100 text-green-800' : applicant.status === 'Under Review' ? 'bg-yellow-100 text-yellow-800' : applicant.status === 'Waitlisted' ? 'bg-red-100 text-red-800' : applicant.status === 'Interview Scheduled' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-130">
                      {applicant.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-131">
                    <a href="#" className="text-indigo-600 hover:text-indigo-900 mr-3" data-id="element-132">
                      View
                    </a>
                    <a href="#" className="text-indigo-600 hover:text-indigo-900" data-id="element-133">
                      Edit
                    </a>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 mt-4" data-id="element-134">
          <div className="flex flex-1 justify-between sm:hidden" data-id="element-135">
            <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-136">
              Previous
            </a>
            <a href="#" className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-137">
              Next
            </a>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-138">
            <div data-id="element-139">
              <p className="text-sm text-gray-700" data-id="element-140">
                Showing <span className="font-medium" data-id="element-141">1</span> to{' '}
                <span className="font-medium" data-id="element-142">8</span> of{' '}
                <span className="font-medium" data-id="element-143">67</span> results
              </p>
            </div>
            <div data-id="element-144">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-145">
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-146">
                  <span className="sr-only" data-id="element-147">Previous</span>
                  <span data-id="element-148">«</span>
                </a>
                <a href="#" aria-current="page" className="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-149">
                  1
                </a>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-150">
                  2
                </a>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-151">
                  3
                </a>
                <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-152">
                  ...
                </span>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-153">
                  8
                </a>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-154">
                  9
                </a>
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-155">
                  <span className="sr-only" data-id="element-156">Next</span>
                  <span data-id="element-157">»</span>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </Card>
    </div>;
};